<template>
  <div class="supplier-contracts-list-container">
    <!-- 顶部标题栏 -->
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>采购合同</span>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-input
        v-model="searchParams.contractName"
        placeholder="合同名称"
        clearable
        class="search-input"
        prefix-icon="el-icon-search"
      ></el-input>
      
      <el-input
        v-model="searchParams.orgName"
        placeholder="供应商名称"
        clearable
        class="search-input"
        prefix-icon="el-icon-office-building"
      ></el-input>
      
      <el-select
        v-model="searchParams.status"
        placeholder="状态"
        clearable
        class="search-input"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button v-permission="'contracts:supplier-contracts-list:create'" type="success" @click="addNewContract">新增采购合同</el-button>
    </div>
    
    <!-- 合同列表 -->
    <el-table
      :data="contractList"
      border
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column
        prop="contractName"
        label="合同名称"
        min-width="220"
      ></el-table-column>
      
      <el-table-column
        prop="supplierName"
        label="供应商名称"
        min-width="180"
      ></el-table-column>
      
      <el-table-column
        prop="status"
        label="状态"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag 
            :type="getStatusTagType(scope.row.status)"
          >
            {{ scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="180"
        align="center"
      ></el-table-column>
      
      <el-table-column
        label="操作"
        width="220"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="viewContract(scope.row.id)"
            >查看</el-button>
            
            <el-button
              v-if="isCreatedByCurrentUser(scope.row) && isEditableStatus(scope.row)"
              v-permission="'contracts:supplier-contracts-list:edit'"
              type="warning"
              size="mini"
              @click="editContract(scope.row.id)"
            >编辑</el-button>
            
            <el-button
              v-if="isCreatedByCurrentUser(scope.row) && isEditableStatus(scope.row)"
              v-permission="'contracts:supplier-contracts-list:delete'"
              type="danger"
              size="mini"
              @click="deleteContract(scope.row.id)"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/api';

export default {
  name: 'SupplierContractsList',
  data() {
    return {
      searchParams: {
        contractName: '',
        orgName: '',
        status: ''
      },
      statusOptions: [
        { value: 'DRAFT', label: '草稿' },
        { value: 'ACTIVE', label: '签订' },
        { value: 'EXECUTING', label: '执行中' },
        { value: 'SETTLED', label: '决算' },
        { value: 'FINISHED', label: '收尾' },
        { value: 'TERMINATED', label: '终止' }
      ],
      loading: false,
      contractList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      debugMode: true,
      forceShowAllButtons: true,
      originalResponse: null,
      currentSupplierId: null,
      allContractList: []
    };
  },
  created() {
    const userInfo = this.$store.state.userInfo || {};
    this.currentSupplierId = userInfo.unitId;
if (!this.currentSupplierId) {
      this.$message.error('无法获取供应商信息，请重新登录');
      return;
    }
    
    // 检查URL参数，如果有refresh=true则强制刷新
    const needRefresh = this.$route.query.refresh === 'true';
    if (needRefresh) {
// 在URL中删除refresh参数
      this.$router.replace({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { refresh: undefined })
      });
    }
    
    // 获取合同列表
    this.getContractList();
  },
  methods: {
    // 获取合同列表
    getContractList() {
      this.loading = true;
      this.allContractList = []; // 清空合并列表
      
      if (!this.currentSupplierId) {
        this.$message.error('无法获取单位信息，请重新登录');
        this.loading = false;
        return;
      }
      
      // 构建查询参数
      const params = {
        page: this.pagination.currentPage, // 前端页码从1开始
        size: this.pagination.pageSize,
        sortBy: 'id',
        sortDir: 'desc'
      };
      
// 使用新的采购合同API
      api.contracts.query_purchase_contracts_pagination(this.currentSupplierId, params)
        .then((response) => {
// 处理响应数据
          if (response.data && response.data.success && response.data.data) {
            const data = response.data.data;
            const contracts = data.content || [];
            
// 存储原始数据
            this.allContractList = contracts;
            
            // 更新分页信息
            this.pagination.total = data.totalElements || 0;
            
            // 初始化显示列表
            this.applyClientSideFilter();
            
} else {
            console.error('查询采购合同失败:', response.data?.message || '未知错误');
            this.$message.error(response.data?.message || '查询采购合同失败');
            this.contractList = [];
            this.pagination.total = 0;
          }
        })
        .catch(error => {
          console.error('获取采购合同列表失败:', error);
          this.$message.error('获取采购合同列表失败，请稍后重试');
          this.contractList = [];
          this.pagination.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 搜索
    handleSearch() {
// 注意：当前API不支持搜索参数，这里实现客户端过滤
      // 未来API支持搜索时，应该重新调用getContractList()并传递搜索参数
      
      if (!this.searchParams.contractName && !this.searchParams.orgName && !this.searchParams.status) {
        // 如果没有搜索条件，显示所有合同
        this.applyClientSideFilter();
        return;
      }
      
      // 实现客户端过滤
      this.applyClientSideFilter();
    },
    
    // 应用客户端过滤 (临时方案，直到API支持搜索参数)
    applyClientSideFilter() {
      let filteredList = [...this.allContractList];
      
      // 按合同名称过滤
      if (this.searchParams.contractName) {
        filteredList = filteredList.filter(item => 
          item.contractName && 
          item.contractName.toLowerCase().includes(this.searchParams.contractName.toLowerCase())
        );
      }
      
      // 按状态过滤
      if (this.searchParams.status) {
        const statusMap = {
          'DRAFT': '草稿',
          'ACTIVE': '签订', 
          'EXECUTING': '执行中',
          'SETTLED': '决算',
          'FINISHED': '收尾',
          'TERMINATED': '终止'
        };
        const targetStatus = statusMap[this.searchParams.status];
        
        filteredList = filteredList.filter(item => {
          const itemStatus = statusMap[item.status] || item.status;
          return itemStatus === targetStatus;
        });
      }
      
      // 更新显示的合同列表
      this.contractList = filteredList.map(item => {
        // 从contractParties中获取供应商信息
        let supplierName = '未知供应商';
        if (item.contractParties && item.contractParties.length > 0) {
          // 检查是否有CUSTOMER类型的party
          const customerParty = item.contractParties.find(party => party.partyType === 'CUSTOMER');
          if (customerParty) {
            // 如果有CUSTOMER类型，则从creator的unitInfo中获取供应商名称
            if (customerParty.unitInfo) {
              supplierName = customerParty.creator.unitName;
            }
          } else {
            // 如果没有CUSTOMER类型，按原逻辑查找SUPPLIER类型
            const supplierParty = item.contractParties.find(party => party.partyType === 'SUPPLIER');
            if (supplierParty && supplierParty.unitInfo) {
              supplierName = supplierParty.unitInfo.unitName;
            }
          }
        }
        
        // 处理状态值映射
        let status = item.status;
        const statusMap = {
          'DRAFT': '草稿',
          'ACTIVE': '签订', 
          'EXECUTING': '执行中',
          'SETTLED': '决算',
          'FINISHED': '收尾',
          'TERMINATED': '终止'
        };
        status = statusMap[status] || status;
        
        return {
          id: item.id,
          contractName: item.contractName,
          contractNumber: item.contractNumber,
          supplierName: supplierName,
          status: status,
          contractAmount: item.contractAmount,
          createTime: item.createTime ? this.formatDate(item.createTime) : '',
          creatorId: item.creatorId,
          creatorName: item.creatorName,
          _raw: item
        };
      });
      
      // 更新分页总数
      this.pagination.total = filteredList.length;
      
},
    
    // 页码改变
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.getContractList();
    },
    
    // 每页条数改变
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.currentPage = 1;
      this.getContractList();
    },
    
    // 查看合同详情
    viewContract(id) {
      // 查找当前合同对象 (从原始数据中查找)
      const contract = this.allContractList.find(item => item.id === id);
      
      if (contract) {
        // 检查当前用户是否为合同的创建者
        const isCreator = String(this.currentSupplierId) === String(contract.creatorId);
// 根据contractType判断跳转不同的合同查看页面
        if (contract.contractType === 'CUSTOMER') {
          // 客户合同类型
          if (isCreator) {
            // 如果是当前用户创建的合同，跳转到preview页面
            this.$router.push({
              path: `/contracts/customer/view/${id}`
            });
          } else {
            // 如果不是当前用户创建的合同，跳转到confirm页面
            this.$router.push({
              path: `/contracts/customer-contract-confirm/${id}`
            });
          }
        } else {
          // 采购合同类型（默认）
          if (isCreator) {
            // 如果是当前用户创建的合同，跳转到preview页面
            this.$router.push({
              path: `/contracts/supplier/preview/${id}`
            });
          } else {
            // 如果不是当前用户创建的合同，跳转到confirm页面
            this.$router.push({
              path: `/contracts/supplier-contract-confirm/${id}`
            });
          }
        }
      } else {
        console.error('未找到ID为', id, '的合同');
        this.$message.error('未找到该合同信息');
      }
    },
    
    // 编辑合同
    editContract(id) {
      this.$router.push({
        path: `/contracts/supplier-contract-edit/${id}`
      });
    },
    
    // 新增供应商合同
    addNewContract() {
      this.$router.push({
        path: '/contracts/supplier-contract-edit'
      });
    },
    
    // 删除合同
    deleteContract(id) {
      this.$confirm('确认删除该合同?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.contracts.del_contract_by_id(id)
          .then(response => {
            if (response.data && response.data.success) {
              this.$message.success('删除成功');
              this.getContractList();
            } else {
              this.$message.error(response.data.message || '删除失败');
            }
          })
          .catch(error => {
            console.error('删除合同失败:', error);
            this.$message.error('删除失败');
          });
      }).catch(() => {
        // 取消删除
      });
    },
    
    // 获取状态对应的标签类型
    getStatusTagType(status) {
      const statusMap = {
        '草稿': 'info',
        '签订': 'primary',
        '执行中': 'success',
        '决算': 'warning',
        '收尾': 'info',
        '终止': 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    // 判断是否为可编辑状态
    isEditableStatus(row) {
      // 只有草稿和签订状态的合同可以编辑
      return row.status === '草稿' || row.status === '签订';
    },
    
    // 判断是否为当前用户创建的合同
    isCreatedByCurrentUser(row) {
      return String(this.currentSupplierId) === String(row.creatorId);
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      try {
        return moment(dateString).format('YYYY-MM-DD');
      } catch (error) {
        console.error('日期格式化错误:', error);
        return dateString;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.supplier-contracts-list-container {
  padding: 20px;
  background-color: #fff;
  
  .page-header {
    margin-bottom: 20px;
    
    .header-title {
      display: flex;
      align-items: center;
      
      .title-mark {
        width: 4px;
        height: 18px;
        background-color: #2c73eb;
        margin-right: 8px;
      }
      
      span {
        font-size: 18px;
        font-weight: 500;
        color: #303133;
      }
    }
  }
  
  .search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    .search-input {
      width: 220px;
      margin-right: 15px;
      margin-bottom: 10px;
    }
    
    .el-button {
      padding: 11px 20px;
      margin-bottom: 10px;
    }
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  
  .debug-info {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
    background-color: #f5f5f5;
    padding: 2px 5px;
    border-radius: 3px;
  }
}
</style>